import EmailValidator from "email-validator";

export default function isEmail(email: string): boolean {
  return EmailValidator.validate(email);
}
